import { PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { BaseInput, baseInputClasses, Typography } from "@kaltura/ds-react-components";

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.danger.main,
    boxSizing: "border-box",
    marginTop: theme.spacing(1),
}));

export const StyledInput = styled(BaseInput)<{ error?: boolean }>(({ theme, error }) => ({
    width: "100%",
    // prevent old styles from overriding this ds input styles when rendered on a no-ds page
    [`.${baseInputClasses.input}`]: {
        color: theme.kaltura.palette.tone1,
        marginBottom: 0,
    },
    ...(
        error && {
            /* Acknowledgement/Danger */
            border: `1px solid ${theme.kaltura.palette.danger.main}`,
        }
    ),
}));

export const FormFieldError = ({ children }: PropsWithChildren) => {
    return (
        <div className={"kms-ds-form-field-error"}>
            <ErrorText variant={"body2"}>{children}</ErrorText>
        </div>
    );
};
